import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, viewMenu } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) center/ cover no-repeat`}
          column
          justifyBetween
          alignCenter
        >
          <CFView
            textCenter
            column
            center
            w="100%"
            ph="5%"
            pt="10px"
            // bg="rgba(0, 0, 0, 0.85)"
            // style={{
            //   backdropFilter: 'blur(10px)',
            //   webkitBackdropFilter: 'blur(10px)',
            // }}
          >
            <CFImage src={heroText} w="100%" alt="Promotions" />
            <CFView pulsate mt="15px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) left / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignEnd
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <CFView w="38%" column center mr="3%">
            <CFImage src={heroText} w="100%" alt="Promotions" />
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
